var option_webview_default = {
  "option": "-MKa8",
  "user_choice": "_2KL0s",
  "check": "-SfWv",
  "image": "_69iPI",
  "input": "LNpwN",
  "title": "XmhZx",
  "centered": "-GN9Y",
  "with_result": "GEz9-",
  "list": "rY9gS",
  "with_image": "yzVcf",
  "progress": "s3iso",
  "progress_value": "ZUF0A",
  "label": "eIBnq",
  "cta": "_5A-3W",
  "adornment_icon": "mmoAb",
  "remove": "hOLQC",
  "removeButton": "z9rs0",
  "removeButtonIcon": "Vi771",
  "overlay": "e8cJx",
  "shown": "XEip5",
  "dark": "_8MIrB",
  "spinner": "PeR-k",
  "spin": "_672cF",
  "grid": "oLpDY"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
